import { Card, Table, TableBody, TableCell, TableHeader, TableRow } from '@catering/ui';
import type { JSX } from 'react';

import type { DeliveryNote } from '../../../delivery-notes/api';

export interface DeliveryNoteItemsTabProps {
  note: DeliveryNote;
}

/**
 * Frozen snapshot, no prices (`StoredDeliveryNoteItem` never carries
 * `unitPriceCents`/`vatRate` — decision 5, audit-only). `revision` is shown
 * next to the section title whenever it is greater than 0, the same number
 * the PDF prints (`design.md` §8.1/§8.3).
 */
export function DeliveryNoteItemsTab({ note }: DeliveryNoteItemsTabProps): JSX.Element {
  // No screen edits the delivered quantity, so the column only matters when it differs.
  const showDelivered = note.items.some((item) => item.deliveredQuantity !== item.orderedQuantity);

  return (
    <Card>
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <h2 className="text-base font-semibold text-slate-900">Ítems del remito</h2>
        {note.revision > 0 ? (
          <span className="text-sm font-medium text-amber-700">Revisión {note.revision}</span>
        ) : null}
      </div>

      <Table>
        <caption className="sr-only">Ítems del remito</caption>
        <thead>
          <tr>
            <TableHeader>Menú</TableHeader>
            <TableHeader>Cantidad pedida</TableHeader>
            {showDelivered ? <TableHeader>Cantidad entregada</TableHeader> : null}
          </tr>
        </thead>
        <TableBody>
          {note.items.map((item) => (
            <TableRow key={item.id}>
              <TableCell>{item.menuNameSnapshot}</TableCell>
              <TableCell>{item.orderedQuantity}</TableCell>
              {showDelivered ? <TableCell>{item.deliveredQuantity}</TableCell> : null}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}
